export enum ERoles {
  OrganizationUser = "OrganizationUser",
  OrganizationAdmin = "OrganizationAdmin",
  SuperAdmin = "SuperAdmin",
  Admin = "Admin", // TODO: Remove this role
  User = "User", // TODO: Remove this role
}
